import PageShell from '@/components/PageShell';

export default function NotFoundPage() {
  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-24 lg:py-32 text-center">
        <p className="text-xs uppercase tracking-wider text-slate-500 mb-4">404</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">Page not found</h1>
        <p className="text-slate-400 mb-10 max-w-md mx-auto">
          That URL does not exist on this site. Head back home or use the navigation.
        </p>
        <a href="/" className="btn-glow inline-flex items-center justify-center px-6 py-3 rounded-lg text-sm font-semibold text-white">
          Back to home
        </a>
      </div>
    </PageShell>
  );
}
